<template>
  <div class="mx-auto my-10 d-flex justify-center" style="text-align: center;">
    <v-img :src="TitleName" :alt="AltText" width="100%" max-width="640"></v-img>
  </div>
</template>

<script>
  export default {
    props: {
      TitleName: {
        type: String,
        default: "http://d-mebius.com/miasmabreaker/assets/index_about.png",
        required: true,
      },
      AltText: {
        type: String,
        default: "Title Image",
        required: true,
      },
    },
  };
</script>
